import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { UnitType } from 'enums/unitType';
import { Optional } from 'functions/promiseExtensions';

export function callApi(type: UnitType): Promise<Optional<ResponseUnit[]>> {
	const url = `${SERVICEBASEURL.BACKEND}/Unit/GetByType`;
	const params: Parameter = { Type: type };
	return axios.get(url, { params: params }).toOptionalMapped((x) => x.data.units);
}

interface Parameter {
	Type: UnitType;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	units: ResponseUnit[];
};

export type ResponseUnit = {
	id: string;
	description: string;
};
